import { ChevronDown } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

const languages = [
  { code: 'en', label: 'English', iconSrc: '/Uploads/eng.svg' },
  { code: 'fr', label: 'Français', iconSrc: '/Uploads/fr.svg' },
]

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation()
  const currentLang = languages.find((language) => language.code === i18n.language) ?? languages[0]

  const handleLanguageChange = (code: string) => {
    i18n.changeLanguage(code)
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="gap-1.5 px-2"
          aria-label={t('language.switch')}
        >
          <img src={currentLang.iconSrc} alt="" className="h-4 w-4 object-contain" aria-hidden="true" />
          <ChevronDown className="h-3.5 w-3.5 text-muted-foreground" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{t('language.title')}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {languages.map((language) => (
          <DropdownMenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            className="cursor-pointer"
          >
            <img
              src={language.iconSrc}
              alt=""
              className="mr-2 h-4 w-4 object-contain"
              aria-hidden="true"
            />
            <span className={i18n.language === language.code ? 'font-semibold' : ''}>
              {language.label}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
